/* eslint-disable dot-notation */
/* eslint-disable no-console */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable import/extensions */
import { API } from 'aws-amplify';

// eslint-disable-next-line no-unused-vars
function init(arg0: string, arg1: string, _init: any, any: any)
{
	throw new Error('Function not implemented.');
}

export function getNotifications(query): Promise<any>
{
	return API.get('notification', `/fetchNotifications/${query}`, init);
}

export function updateNotifications(body): Promise<any>
{
	return API.put('notification', '/updateNotification', { body });
}
